<div class="image-crop">
  @if (inputData?.label) {
    <span class="image-crop__title">{{ inputData?.label }}</span>
  }
  @if (hint) {
    <p class="image-crop__hint">{{ hint }}</p>
  }

  <label class="image-crop__picker">
    <input
      type="file"
      class="image-crop__file"
      [accept]="accept"
      (change)="onFileSelected($event)" />
    <span class="image-crop__picker-btn">Choose image</span>
    <span class="image-crop__filename">{{ fileName || 'No file chosen' }}</span>
  </label>

  @if (imageValue) {
    <div class="image-crop__preview">
      <span class="image-crop__preview-label">Preview</span>
      <div class="image-crop__preview-body">
        <img
          [src]="imageValue"
          alt="image preview"
          class="image-crop__preview-img" />
        <button
          type="button"
          class="image-crop__remove"
          (click)="removeImage()">
          Remove
        </button>
      </div>
    </div>
  }
</div>
